















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import isEmpty from 'lodash/isEmpty'

import Default from '../components/common/Default.vue'
import { ActionFetchAll, User } from '../store/user/types'
import { isDevMode, sortFilterUsers } from '../lib/appHelper'
import UserCard from '../components/pages/home/UserCard.vue'
import { Page, UserSearchFormParams } from '../type'
import LoadingModal from '../components/common/LoadingModal.vue'
import UserDetailDialog from '../components/pages/home/UserDetailDialog.vue'
import UserFilterDialog from '../components/pages/home/UserFilterDialog.vue'

const USERS_PER_PAGE = 30
const UserModule = namespace('user')
const AppModule = namespace('app')

@Component({
  components: {
    Default,
    LoadingModal,
    UserCard,
    UserDetailDialog,
    UserFilterDialog
  }
})
export default class Users extends Vue {
  @UserModule.Action('fetchAll') fetchAll!: ActionFetchAll
  @AppModule.Getter('searchParams') searchParams!: UserSearchFormParams

  users: User[] = []
  displayUsers: User[] = []
  selected: User | null = null
  openUser = false
  openFilter = false
  page = 1
  loading = false

  get isDevMode() {
    return isDevMode
  }

  get usersPerPage() {
    const start = USERS_PER_PAGE * (this.page - 1)
    return this.displayUsers.slice(start, start + USERS_PER_PAGE)
  }

  get totalPages() {
    return Math.ceil(this.displayUsers.length / USERS_PER_PAGE)
  }

  get hasUsers() {
    return !isEmpty(this.users)
  }

  mounted() {
    this.fetchAllUsers()
  }

  @Watch('$route', { immediate: true })
  updatedRoute() {
    const page = this.$route.query.page
    if (page) this.page = +page
  }

  handleChangePage(page: number) {
    this.$router.push({ name: Page.Users, query: { page: page.toString() } })
    window.scrollTo(0, 0)
  }

  fetchAllUsers() {
    this.loading = true
    this.fetchAll()
      .then(users => {
        this.users = users.filter(u => u.updatedAt && !u.admin)
        this.displayUsers = sortFilterUsers(this.users, this.searchParams)
      })
      .finally(() => {
        this.loading = false
      })
  }

  handleSelect(user: User) {
    this.selected = user
    this.openUser = true
  }

  handleFilter(users: User[]) {
    this.displayUsers = users
    this.openFilter = false
    this.page = 1
  }
}
